import _ from 'underscore';
import Backbone from 'backbone';
import { state } from '../../state-manager/state-model';
import { domainReplacer } from '../../utils/domain-replacer';
import { ERRORS } from '../../utils/handle-error';
import { LINKS } from '../../config';
import tpl from './passwd-template.ejs';

var MAX_PASSWD_LENGTH = 4;

export var PasswdView = Backbone.View.extend({
  tagName: 'div',

  template: tpl,

  events: {
    'click [data-passwd-click=confirm]': 'confirm',
    'click [data-passwd-click=number]': 'inputNumber',
    'click [data-passwd-click=reset]': 'reset',
    'click [data-passwd-click=cancel]': 'cancel'
  },

  initialize: function () {
    _.bindAll(this, 'inputNumber');

    var replaceURL = domainReplacer.create();
    this.imagePath = state.get('imagePath');
    this.changePWLink = replaceURL(LINKS.changePersonalPassword);
    this.unregisterLink = replaceURL(LINKS.unregisterPersonalPassword);

    this.padNumbers = _.shuffle([0, 1, 2, 3, 4, 5, 6, 7, 8, 9]);

    this.listenTo(this.model, 'change', this.render);
    this.listenTo(this.model, 'sync', this.checkAuthorized);
  },

  render: function () {
    var rendered = this.template(
      _.extend(this.model.toJSON(), {
        imagePath: this.imagePath,
        changePWLink: this.changePWLink,
        unregisterLink: this.unregisterLink,
        padNumbers: this.padNumbers
      })
    );
    this.$el.html(rendered);
    return this;
  },

  inputNumber: function (e) {
    e.preventDefault();
    var $el = $(e.currentTarget);
    var num = $el.html();

    if (this.model.get('inputValue').length === MAX_PASSWD_LENGTH) {
      return;
    }
    this.model.add(num);
  },

  cancel: function (e) {
    e.preventDefault();
    this.trigger('fail', {
      resultCode: ERRORS.Silent
    });
    this.remove();
  },

  confirm: function (e) {
    e.preventDefault();
    if (this.model.get('isReady')) {
      this.model.authenticate();
    }
  },

  reset: function (e) {
    e.preventDefault();
    this.model.reset();
  },

  checkAuthorized: function () {
    var isSuccess = this.model.get('isSuccess');

    if (isSuccess) {
      state.authenticateMFA(true);
      this.trigger('success');
      this.remove();
    } else {
      this.trigger('fail', {
        resultCode: this.model.get('resultCode'),
        resultText: this.model.get('resultText')
      });
      this.remove();
    }
  }
});
